/* eslint-disable */
export default {
  to: 'Para',
  enterNameOrNumber: 'Inserir nome ou número',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
